/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Inbound_Waiting_On_ExceptionInputs */

const en_inbound_waiting_on_exception = /** @type {(inputs: Inbound_Waiting_On_ExceptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on Logistics or Operations · failed check · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on Logistics or Operations · failed check · since {since}" |
*
* @param {Inbound_Waiting_On_ExceptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_waiting_on_exception = /** @type {((inputs: Inbound_Waiting_On_ExceptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Waiting_On_ExceptionInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_waiting_on_exception(inputs)
});